import React from 'react';

import { SVGComponentProps } from './svg.types';

//size parameter not replaced as this svg is used only on dashboard
const DashboardBulbSVG = ({
  fill = 'currentColor',
  size = '1em',
  stroke = 'currentColor',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect width="40" height="40" rx="20" fill="#142A76" />
        <path
          d="M17 26H23"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 30H22"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.09 22C23.27 21.02 23.74 20.26 24.5 19.5C24.9829 19.0555 25.3662 18.5138 25.6247 17.9106C25.8832 17.3073 26.0111 16.6562 26 16C26 14.4087 25.3679 12.8826 24.2426 11.7574C23.1174 10.6321 21.5913 10 20 10C18.4087 10 16.8826 10.6321 15.7574 11.7574C14.6321 12.8826 14 14.4087 14 16C14 17 14.23 18.23 15.5 19.5C16.2241 20.1621 16.718 21.0379 16.91 22"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default DashboardBulbSVG;
